import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';

function Footer() {
  return (
    <footer className="w-full relative bg-gray-900 text-white">
      <div className="container mx-auto w-full grid grid-cols-1 md:grid-cols-6 px-10 py-8 gap-6 relative z-20">
        {/* Mapa */}
        <div className="col-span-2 md:col-span-1">
          <div className="relative h-56 w-full overflow-hidden border rounded-lg shadow-lg">
            <iframe
              title="Mapa de Google de Padre Mariano 82, Oficina 503"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10813.472415431524!2d-70.616614!3d-33.4261!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf63905aaaab%3A0x2bb2f0323592d648!2sPadre%20Mariano%2082%2C%20Oficina%20503%2C%207500026%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e1!3m2!1ses-419!2scl!4v1751904275711!5m2!1ses-419!2scl"
              style={{ border: 0, position: 'absolute' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full"
            />
          </div>
        </div>

        {/* Logo + descripción */}
        <div className="flex flex-col items-start justify-center col-span-2">
          <div className="h-20 hidden md:block ">
            <Link to="/">
              <img
                src="https://www.andes-tec.cl/_next/image?url=https%3A%2F%2Fdps2wxsijib8x.cloudfront.net%2Fimagenes-generales%2Fextras%2Fandes-tec-footer.webp&w=640&q=75"
                alt="Logo Andes-TEC"
                className="object-contain w-full h-full"
              />
            </Link>
          </div>
          <p className="text-sm text-gray-300">
            Somos una empresa especializada en la venta de equipos de radiocomunicación de la marca Hytera, reconocida a nivel mundial por su innovación y calidad. Ofrecemos soluciones de comunicación seguras, eficientes y personalizadas para distintos sectores, como seguridad, transporte, industria y servicios públicos. Brindamos asesoría técnica, soporte y servicio postventa para garantizar el óptimo funcionamiento de cada sistema.
          </p>
        </div>

        {/* Espaciado visual */}
        <div className="hidden md:block" />

        {/* Enlaces */}
        <div className="hidden md:block">
          <h3 className="text-lg font-bold mb-4">Productos Hytera</h3>
          <ul className="space-y-2">
            <li>
              <Link
                to="/productos/radios-portatiles"
                className="text-gray-300 hover:text-white transition uppercase"
              >
                Radios Portátiles
              </Link>
            </li>
            <li>
              <Link
                to="/productos/radios-moviles"
                className="text-gray-300 hover:text-white transition uppercase"
              >
                Radios Móviles
              </Link>
            </li>
            <li>
              <Link
                to="/productos/repetidoras"
                className="text-gray-300 hover:text-white transition uppercase"
              >
                Repetidoras
              </Link>
            </li>
            <li>
              <Link
                to="/productos/bodycams"
                className="text-gray-300 hover:text-white transition uppercase"
              >
                Bodycams
              </Link>
            </li>
            <li>
              <Link
                to="/productos/equipos-poc"
                className="text-gray-300 hover:text-white transition uppercase"
              >
                Equipos PoC
              </Link>
            </li>
          </ul>
        </div>

        {/* Contacto */}
        <div className="col-span-2 md:col-span-1">
          <h3 className="text-lg font-bold mb-4 hidden md:block">Contacto</h3>
          <ul className="space-y-4">
            <li className="flex items-center">
              <FontAwesomeIcon icon={faPhoneAlt} className="mr-2 text-purple-400" />
              <span className="text-gray-300">+56 2 2247 8223</span>
            </li>
            <li className="flex items-center">
              <FontAwesomeIcon icon={faEnvelope} className="mr-2 text-purple-400" />
              <span className="text-gray-300">ventas@andes-tec.cl</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Derechos reservados */}
      <div className="bg-purple-950 py-4 relative z-10">
        <p className="text-center text-gray-200 text-sm">
          ©2025 Andes-TEC. Todos los derechos reservados.
        </p>
      </div>

      {/* Fondo del footer */}
      <img
        src="https://cdnx.jumpseller.com/radioclub/image/49293391/thumb/1438/1438?1723854822"
        alt="Fondo footer Andes-TEC"
        className="object-cover w-full h-full absolute top-0 left-0 z-0 opacity-30"
      />
    </footer>
  );
}

export default Footer;
